import { useState, useEffect } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { TextField, Popover, InputAdornment } from "@mui/material";
import { ReactComponent as CalendarIcon } from "../../../images/svg/calendar.svg";
import { ReactComponent as ArrowIcon } from "../../../images/svg/arrow-circle-right.svg";
import format from "date-fns/format";

export default function CustomDateRangePicker({ value, onChange }) {
  const [range, setRange] = useState([
    {
      startDate: value?.[0] || new Date(),
      endDate: value?.[1] || new Date(),
      key: "selection",
    },
  ]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    setRange([
      {
        startDate: value?.[0] || new Date(),
        endDate: value?.[1] || new Date(),
        key: "selection",
      },
    ]);
  }, [value]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setRange([ranges.selection]);
    onChange([startDate, endDate]);
  };

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? "date-range-popover" : undefined;

  const formattedValue =
    range[0].startDate && range[0].endDate
      ? `${format(range[0].startDate, "dd-MM-yyyy")}  -  ${format(range[0].endDate, "dd-MM-yyyy")}`
      : "Select date";

  return (
    <>
      <TextField
        value={formattedValue}
        size="small"
        variant="outlined"
        onClick={handleOpen}
        InputProps={{
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <CalendarIcon style={{ width: 18, height: 18, marginRight: "5px" }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <ArrowIcon style={{ width: 18, height: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          minWidth: 275,
          "& .MuiOutlinedInput-root": {
            borderRadius: "24px",
            padding: "0 8px",
            display: "flex",
            alignItems: "center",
            "&.Mui-focused fieldset": {
              borderColor: "#ccc",
              borderWidth: "1px",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
            borderWidth: "1px",
          },
          input: { cursor: "pointer", textAlign: "left" },
        }}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <DateRange
          ranges={range}
          onChange={handleSelect}
          moveRangeOnFirstSelection={false}
          maxDate={new Date()}
          showDateDisplay={false}
        />
      </Popover>
    </>
  );
}
